import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import hoursToDuration from 'utils/hours-to-duration';


// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface Props {
    totalPaidMinutes?: ?number;
}

export class TimesheetEntryTotalPaidMinutes extends React.PureComponent<Props> {
    render() {
        const { totalPaidMinutes } = this.props;
        if (!totalPaidMinutes) return null;
        return hoursToDuration(totalPaidMinutes/60)
    }
}

const mapStateToProps = createStructuredSelector({
    totalPaidMinutes: makeSelectTimesheetEntryValue('totalPaidMinutes')
});

export default connect(mapStateToProps)(TimesheetEntryTotalPaidMinutes);
